<template>
  <div>
    <v-container fluid :class="asDialog ? 'px-4 px-sm-15' : 'px-15'">
      <!-- Spinner de carga -->
      <v-overlay :value="isLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <!-- Contenido -->
      <template v-if="!isLoading">
        <div v-if="!asDialog" style="position: absolute;">
          <v-btn @click="$router.go(-1)" text class="pl-0">
            <v-icon class="mr-1" size="15px"> mdi-arrow-left </v-icon>
            <span class="text-return mon-regular" style="font-family: 'montserrat-medium';">{{ "Regresar" }}</span>
          </v-btn>
        </div>

        <!-- Titulo -->
        <v-row class="mt-6" justify="center" style="align-items: center;">
          <v-col cols="12" sm="6" md="">
            <h1
              class="mb-3"
              style="font-family: 'montserrat-bold'; color: black;"
              :style="{ fontSize: $vuetify.breakpoint.xsOnly ? '24px' : '32px', whiteSpace: $vuetify.breakpoint.xsOnly ? 'normal' : 'nowrap' }"
            >
              {{ "Detalle de pago" }}
            </h1>
          </v-col>
          <v-col cols="6" sm="3" md="2">
            <v-btn block class="action-btn white--text" color="black" @click="openReceipt()">
              Descargar
              <v-icon right>mdi-download</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="6" sm="3" md="2">
            <v-btn
              block
              class="action-btn white--text"
              color="black"
              @click="changeStatus()"
            >
              Cambiar estatus
              <v-icon right>mdi-compare-horizontal</v-icon>
            </v-btn>
          </v-col>
          <!-- <v-col cols="2">
            <v-btn block class="action-btn primary" @click="openReceipt()">
              CEP
              <v-icon right>mdi-download</v-icon>
            </v-btn>
          </v-col> -->
        </v-row>

        <!-- Cards -->
        <v-row class="mt-2" justify="center" style="align-items: flex-end;">
          <v-col>
            <v-card class="info-card">
              <div class="info-block">
                <p class="label">Id:</p>
                <p class="value">{{ item?.iTrackingId }}</p>
              </div>
              <div class="info-block mb-0">
                <p class="label">Status:</p>
                <p class="value">
                  <v-chip outlined :color="setStatusColor(item?.status.sName)" style="text-wrap: nowrap; white-space: normal;">
                    {{ item.status.sName }}
                  </v-chip>
                </p>
              </div>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="info-card">
              <div class="info-block">
                <p class="label">Profit (%):</p>
                <p class="value profit-text">{{ item.percentProfit ? formatMoney(item.percentProfit) + " %" : '-' }}</p>
              </div>
              <div class="info-block mb-0">
                <p class="label">Profit ($):</p>
                <p class="value profit-text">{{ item.dollarProfit ? "$" + formatMoney(item.dollarProfit) + " USD" : '-' }}</p>
              </div>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="info-card">
              <div class="info-block">
                <p class="label">Proveedor:</p>
                <p class="value">{{ item.payment_recipient.sName }}</p>
              </div>
              <div class="info-block">
                <p class="label">Nombre de banco:</p>
                <p class="value">{{ item.payment_recipient.sBankName }}</p>
              </div>
              <div class="info-block mb-0">
                <p class="label">Número de cuenta:</p>
                <p class="value">{{ item.payment_recipient.sAccountNumber ?  item.payment_recipient.sAccountNumber : item.payment_recipient.accountNumber }}</p>
              </div>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="info-card">
              <div class="info-block">
                <p class="label">Fecha de pago:</p>
                <p class="value">{{ formatDate(item.created_at) }}</p>
              </div>
              <div class="info-block">
                <p class="label">Tipo de cambio:</p>
                <p class="value">{{ isMXAccount ? (item?.dRate ? "$ " + formatMoney(item?.dRate) + " MXN" : (item?.dPaymentAmount ? "$ " + formatMoney(item?.dDescAmount / item?.dPaymentAmount) + " MXN" : '-')) : (item?.totalActualCost != 0 ? "$ " + formatMoney(item?.dDescAmount / item?.totalActualCost) + " MXN" : (item?.dRate ? "$ " + formatMoney(item?.dRate) + " MXN" : '-')) }}</p>
              </div>
              <v-divider class="my-2"></v-divider>
              <div class="info-block mb-0">
                <p class="label">Monto:</p>
                <template v-if="item?.sCurrency != item?.sDestCurrency">
                  <p class="value amount-text">{{ "$ " + formatMoney(item?.dPaymentAmount) + " " + item?.sCurrency }}</p>
                  <p class="value amount-text">{{ "$ " + formatMoney(item?.dDescAmount) + " " + item?.sDestCurrency }}</p>
                </template>
                <template v-else>
                  <p class="value amount-text">{{ "$ " + formatMoney(item?.dDescAmount) + " " + item?.sDestCurrency }}</p>
                </template>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Tabla de conversiones -->
        <template>
          <!-- Texto -->
          <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 8px;" class="mt-9 mb-3">
            <div
              style="font-family: 'montserrat-bold'; color: #193D6E;"
              :style="{ fontSize: $vuetify.breakpoint.xsOnly ? '20px' : '26px' }"
            >{{ "Conversiones Aplicadas" }}</div>
            <v-chip
              outlined
              color="#0075B8"
              style="background-color: #F0F8FE !important; font-family: 'montserrat-semibold';"
            >
              {{ formatMoney(totalMXNUsed) }} MXN / {{ formatMoney(totalUSDUsed) }} USD
            </v-chip>
          </div>
          <!-- Tabla web -->
          <v-data-table hide-default-header :items="item.transaction" class="d-none d-sm-block">
            <template v-slot:header="{ props }">
              <thead style="background-color: #f9fafd;">
                <tr>
                  <th class="header__title left">{{ "texts.conversions.id" }}</th>                                                                                                                                                                                         
                  <th class="header__title center">{{ "texts.conversions.paymentDate" }}</th>                                                                                                                                                                                                                            
                  <th class="header__title center">{{ "texts.conversions.typeTransaction" }}</th>
                  <th class="header__title center">{{ "texts.conversions.totalAmountUSD" }}</th>
                  <th class="header__title center">{{ "texts.conversions.totalAmountMXN" }}</th>
                  <th class="header__title center">{{ "texts.conversions.exchangeRate" }}</th>
                  <th class="header__title right">{{ "Actions" }}</th>
                </tr>
              </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr v-for="item in items" :key="item.id">
                  <td class="table__item">{{ item.transaction.iTrackingId }}</td>
                  <td class="table__item">{{ formatDate(item.transaction.created_at) }}</td>
                  <td class="table__item">
                    <v-chip v-if="item.transaction.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'" color="#D61518" style="background-color: #FDF0F5 !important;" outlined>
                      {{ "Forward" }}
                    </v-chip>
                    <v-chip v-else-if="item.transaction.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                      {{ "Spot" }}
                    </v-chip>
                    <v-chip v-else-if="item.transaction.sTransactionType == '1e337607-b37b-4491-83b0-6383a45f9481'" color="#0EAB5D" style="background-color: #EFFAF2 !important;" outlined>
                      {{ "Withdrawal" }}
                    </v-chip>
                    <v-chip v-else-if="item.transaction.sTransactionType == 'f588edfa-73d4-4365-a240-90a3339dfdb2'" color="#603CB5" style="background-color: #F4F0F8 !important;" outlined>
                      {{ "Collect" }}
                    </v-chip>
                    <v-chip v-else-if="item.transaction.sTransactionType == 'ea9d350f-f00b-4763-90db-72e7af54dc73'" color="#E8B238" style="background-color: #FDF8EB !important;" outlined>
                      {{ "Pay Now" }}
                    </v-chip>
                    <v-chip v-else-if="item.transaction.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                      {{ "Window spot" }}
                    </v-chip>
                    <h4 v-else>
                      {{ "-" }}
                    </h4>
                  </td>
                  <td class="table__item">$ {{ formatMoney(item.dAmount / (item.transaction.dDesAmount / item.transaction.dAmount)) + " " + item.transaction.sCurrency }} </td>
                  <td class="table__item">{{ item.dAmount ? "$ " + formatMoney(item.dAmount) + " " + item.transaction.sDestCurrency : "-" }}</td>
                  <td class="table__item">{{ item.transaction.dExchangeRate < 1 ? "$ " + formatMoney(1 / item.transaction.dExchangeRate) + " MXN" : formatMoney(item.transaction.dExchangeRate) + " MXN" }}</td>
                  <td class="table__item">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="goToConversion(item)" v-bind="attrs" v-on="on" icon color="black">
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ "texts.conversionsHistory.viewDetail" }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
          <!-- Tabla mobile -->
          <v-data-table class="d-sm-none d-block" hide-default-header :items="item.transaction">
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr class="table__item" style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
                  <td class="table__item__mobile">
                    <div>{{ "texts.conversions.id" }}</div>
                    <div>{{ item.transaction.iTrackingId }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ "texts.conversions.paymentDate" }}</div>
                    <div>{{ formatDate(item.transaction.created_at) }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ "texts.conversions.typeTransaction" }}</div>
                    <div>
                      <v-chip v-if="item.transaction.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'" color="#D61518" style="background-color: #FDF0F5 !important;" outlined>
                        {{ "Forward" }}
                      </v-chip>
                      <v-chip v-else-if="item.transaction.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                        {{ "Spot" }}
                      </v-chip>
                      <v-chip v-else-if="item.transaction.sTransactionType == '1e337607-b37b-4491-83b0-6383a45f9481'" color="#0EAB5D" style="background-color: #EFFAF2 !important;" outlined>
                        {{ "Withdrawal" }}
                      </v-chip>
                      <v-chip v-else-if="item.transaction.sTransactionType == 'f588edfa-73d4-4365-a240-90a3339dfdb2'" color="#603CB5" style="background-color: #F4F0F8 !important;" outlined>
                        {{ "Collect" }}
                      </v-chip>
                      <v-chip v-else-if="item.transaction.sTransactionType == 'ea9d350f-f00b-4763-90db-72e7af54dc73'" color="#E8B238" style="background-color: #FDF8EB !important;" outlined>
                        {{ "Pay Now" }}
                      </v-chip>
                      <v-chip v-else-if="item.transaction.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                        {{ "Window spot" }}
                      </v-chip>
                      <h4 v-else>
                        {{ "-" }}
                      </h4>
                    </div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ "texts.conversions.totalAmountUSD" }}</div>
                    <div>$ {{ formatMoney(item.dAmount / (item.transaction.dDesAmount / item.transaction.dAmount)) }} USD</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ "texts.conversions.totalAmountMXN" }}</div>
                    <div>{{ item.dAmount ? "$ " + formatMoney(item.dAmount) + " MXN" : "-" }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ "texts.conversions.exchangeRate" }}</div>
                    <div>{{ item.transaction.dExchangeRate ? "$ " + formatMoney(item.transaction.dExchangeRate) + " MXN" : "-" }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ "Actions" }}</div>
                    <div>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn @click="goToConversion(item)" v-bind="attrs" v-on="on" icon color="black">
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ "texts.conversionsHistory.viewDetail" }}</span>
                      </v-tooltip>
                    </div>
                  </td>
                </tr>
                <v-divider></v-divider>
              </tbody>
            </template>
          </v-data-table>
        </template>

        <!-- Texto de Facturas -->
        <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 8px;" class="mb-3">
          <div
            style="font-family: 'montserrat-bold'; color: #193D6E;"
            :style="{ fontSize: $vuetify.breakpoint.xsOnly ? '20px' : '26px' }"
          >{{ "Facturas aplicadas" }}</div>
          <div style="display: flex; gap: 12px; align-items: center; flex-wrap: wrap;">
            <v-chip
              v-if="item.invoices && item.invoices.length > 0"
              outlined
              color="#0075B8"
              style="background-color: #F0F8FE !important; font-family: 'montserrat-semibold';"
            >
              TC: $ {{ isMXAccount ? (item?.dRate ? formatMoney(item.dRate) : (item?.dPaymentAmount ? formatMoney(item.dDescAmount / item.dPaymentAmount) : '-')) : (item?.totalActualCost != 0 ? formatMoney(item.dDescAmount / item.totalActualCost) : (item?.dRate ? formatMoney(item.dRate) : '-')) }} MXN
            </v-chip>
            <v-chip
              v-if="item.invoices && item.invoices.length > 0"
              outlined
              color="#0075B8"
              style="background-color: #F0F8FE !important; font-family: 'montserrat-semibold';"
            >
              Profit: $ {{ formatMoney(item.dollarProfit) }} USD / {{ formatMoney(item.percentProfit) }} %
            </v-chip>
          </div>
        </div>
        
        <!-- Botón de agregar factura -->
        <div style="text-align:start; margin: 16px 0;" class="pt-2 pb-2">
          <v-btn
            color="black"
            class="white--text"
            style="border-radius: 36px; border: 2px solid black; font-family: 'montserrat-semibold'; text-transform: none;"
            @click="openAddInvoiceDialog()"
          >
            <v-icon left>mdi-plus</v-icon>
            Agregar factura
          </v-btn>
        </div>
        
        <!-- Tabla de Facturas -->
        <template v-if="item.invoices && item.invoices.length > 0">
          <!-- Tabla web -->
          <v-data-table  hide-default-header :items="item.invoices" class="mb-4 d-none d-sm-block">
            <template v-slot:header="{ props }">
              <thead style="background-color: #f9fafd;">
                <tr>
                  <th class="header__title center">{{ "texts.invoices.invoice" }}</th>
                  <th class="header__title center">{{ "texts.invoices.sId" }}</th>
                  <th class="header__title center" style="text-wrap: wrap;">{{ "texts.conversions.purchaseDate" }}</th>
                  <th class="header__title center" style="text-wrap: wrap;">{{ "texts.conversions.dueDate" }}</th>
                  <th class="header__title center">{{ "texts.invoices.rateProtection" }}</th>
                  <th class="header__title center">{{ isMXAccount ? "Monto USD" : "texts.conversions.totalAmountUSD" }}</th>
                  <th class="header__title center">{{ isMXAccount ? "Monto MXN" : "texts.conversions.totalAmountMXN" }}</th>
                  <th class="header__title center">{{ "texts.conversions.currencyProfit" }}</th>
                  <th class="header__title center">{{ "texts.conversions.dollarProfit" }}</th>
                  <th class="header__title right">{{ "texts.conversions.actions" }}</th>
                </tr>
              </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr v-for="item in items" :key="item.id">
                  <td class="table__item">{{ item.invoice.sInvoice }}</td>
                  <td class="table__item">{{ item.invoice.sId }}</td>
                  <td class="table__item">{{ formatDate(item.invoice.dPurchaseDate) }}</td>
                  <td class="table__item">{{ formatDate(item.invoice.dDueDate) }}</td>
                  <td class="table__item">{{ "$ " + formatMoney(item.invoice.dRateProtection) + " MXN" }}</td>
                  <template v-if="isMXAccount">
                    <td class="table__item">$ {{ formatMoney(item.invoice.dTotalAmount) }} USD</td>
                    <td class="table__item">{{ "$ " + formatMoney(item.invoice.dTotalAmount * item.invoice.dRateProtection) + " MXN" }}</td>
                  </template>
                  <template v-else>
                    <td class="table__item">$ {{ formatMoney(item.totalOrignAmount) }} USD</td>
                    <td class="table__item">{{ "$ " + formatMoney(item.totalDescAmount) + " MXN" }}</td>
                  </template>
                  <td class="table__item" style="color: #0075B8;">{{ "$ " + formatMoney(item.profit) + " USD" }}</td>
                  <td class="table__item" style="color: #0075B8;">{{  formatMoney(item.percentProfit) + "%"  }}</td>
                  <td class="table__item">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="goToInvoice(item.invoice)" v-bind="attrs" v-on="on" icon color="black">
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ "texts.conversionsHistory.viewDetail" }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
          <!-- Tabla mobile -->
          <v-data-table class="d-sm-none d-block" hide-default-header :items="item.invoices">
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr class="table__item" style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
                  <td class="table__item__mobile">
                    <div>{{ "texts.invoices.invoice" }}</div>
                    <div>{{ item.invoice.iTrackingId }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ "texts.invoices.sId" }}</div>
                    <div>{{ item.invoice.sId }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ "texts.conversions.purchaseDate" }}</div>
                    <div>{{ formatDate(item.invoice.dPurchaseDate) }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ "texts.conversions.dueDate" }}</div>
                    <div>{{ formatDate(item.invoice.dDueDate) }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div style="text-wrap: wrap; text-align: start;">{{ "texts.invoices.rateProtection" }}</div>
                    <div>{{ "$ " + formatMoney(item.invoice.dRateProtection) + " MXN" }}</div>
                  </td>
                  <template v-if="isMXAccount">
                    <td class="table__item__mobile">
                      <div>Monto USD</div>
                      <div>$ {{ formatMoney(item.invoice.dTotalAmount) }} USD</div>
                    </td>
                    <td class="table__item__mobile">
                      <div>Monto MXN</div>
                      <div>{{ "$ " + formatMoney(item.invoice.dTotalAmount * item.invoice.dRateProtection) + " MXN" }}</div>
                    </td>
                  </template>
                  <template v-else>
                    <td class="table__item__mobile">
                      <div>{{ "texts.conversions.totalAmountUSD" }}</div>
                      <div>$ {{ formatMoney(item.totalOrignAmount) }} USD</div>
                    </td>
                    <td class="table__item__mobile">
                      <div>{{ "texts.conversions.totalAmountMXN" }}</div>
                      <div>{{ "$ " + formatMoney(item.totalDescAmount) + " MXN" }}</div>
                    </td>
                  </template>
                  <td class="table__item__mobile">
                    <div>{{ "texts.conversions.currencyProfit" }}</div>
                    <div style="color: #0075B8;">{{ "$ " + formatMoney(item.profit) + " USD" }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ "texts.conversions.dollarProfit" }}</div>
                    <div style="color: #0075B8;">{{  formatMoney(item.percentProfit) + "%"  }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ "texts.conversions.actions" }}</div>
                    <div>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn @click="goToInvoice(item.invoice)" v-bind="attrs" v-on="on" icon color="black">
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ "texts.conversionsHistory.viewDetail" }}</span>
                      </v-tooltip>
                    </div>
                  </td>
                </tr>
                <v-divider></v-divider>
              </tbody>
            </template>
          </v-data-table>
        </template>
        
        <!-- Mensaje cuando no hay facturas -->
        <template v-else-if="item.invoices && item.invoices.length === 0">
          <div style="text-align: center; padding: 40px 20px; background: #F6F8FC; border-radius: 16px; margin-top: 16px;">
            <v-icon size="64" color="#868DA6" class="mb-4">mdi-file-document-outline</v-icon>
            <div style="font-family: 'montserrat-semibold'; font-size: 18px; color: #868DA6; margin-bottom: 8px;">
              No hay facturas aplicadas
            </div>
            <div style="font-family: 'montserrat-regular'; font-size: 14px; color: #868DA6;">
              Agrega facturas usando el botón de arriba
            </div>
          </div>
        </template>
        
        <!-- Mensaje cuando no hay datos de facturas -->
        <template v-else>
          <div style="text-align: center; padding: 40px 20px; background: #F6F8FC; border-radius: 16px; margin-top: 16px;">
            <v-icon size="64" color="#868DA6" class="mb-4">mdi-file-document-outline</v-icon>
            <div style="font-family: 'montserrat-semibold'; font-size: 18px; color: #868DA6; margin-bottom: 8px;">
              No hay facturas aplicadas
            </div>
            <div style="font-family: 'montserrat-regular'; font-size: 14px; color: #868DA6;">
              Agrega facturas usando el botón de arriba
            </div>
          </div>
        </template>
      </template>
      
    </v-container>

    <v-dialog v-model="showStatusModal" max-width="600px" persistent>
      <v-card class="status-modal">
        <div class="warning-icon">
          <div class="warning-icon-outer">
            <div class="warning-icon-inner">
              <span class="warning-exclamation">!</span>
            </div>
          </div>
        </div>
        <div class="status-modal-content">
          <h2 class="status-modal-title">¡El pago cambiará de estatus!</h2>
        </div>

        <div class="status-selection-section">
          <div>
            <v-select
              v-model="selectedStatus"
              :items="statusOptions"
              item-text="name"
              item-value="id"
              label="Estatus"
              dense
              hide-details
              background-color="#f5f5f5"
              solo
              flat
              style="border: none; box-shadow: none; width: 100%;"
            ></v-select>
          </div>
        </div>
        
        <div class="payment-details-section">
          <div class="payment-details">
            <div class="detail-row">
              <span class="detail-label">Destinatario:</span>
              <span class="detail-value">{{ item?.payment_recipient?.sName || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Fecha de pago:</span>
              <span class="detail-value">{{ formatDate(item?.created_at) }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Estatus:</span>
              <span class="detail-value">{{ item?.status?.sName || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Monto origen:</span>
              <span class="detail-value">{{ item?.sCurrency ? `$ ${formatMoney(item.dAmount)} ${item.sCurrency}` : '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Monto destinatario:</span>
              <span class="detail-value">{{ item?.sDestCurrency ? `$ ${formatMoney(item?.dDescAmount)} ${item?.sDestCurrency}` : '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Tipo de cambio:</span>
              <span class="detail-value">{{ isMXAccount ? (item?.dRate ? `$ ${formatMoney(item?.dRate)} MXN` : (item?.dPaymentAmount ? `$ ${formatMoney(item?.dDescAmount / item?.dPaymentAmount)} MXN` : '-')) : (item?.totalActualCost != 0 ? `$ ${formatMoney(item?.dDescAmount / item?.totalActualCost)} MXN` : '-') }}</span>
            </div>
          </div>
        </div>

        <div class="status-modal-actions">
          <v-btn
            outlined
            color="black"
            @click="showStatusModal = false"
            class="cancel-btn"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="black"
            class="white--text accept-btn"
            @click="showConfirmationModal"
            :loading="isChangingStatus"
            :disabled="!selectedStatus || selectedStatus === item?.status?.sStatusId"
          >
            Continuar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFinalConfirmationModal" max-width="500px" persistent>
      <v-card class="final-confirmation-modal">
        <div class="warning-icon">
          <div class="warning-icon-outer">
            <div class="warning-icon-inner">
              <span class="warning-exclamation">!</span>
            </div>
          </div>
        </div>
        <div class="final-confirmation-content">
          <h2 class="final-confirmation-title">El pago cambiará a estatus: {{ getStatusName(selectedStatus) }}</h2>
          <p class="final-confirmation-description">
            Este cambio pasará las facturas asignadas a "TO PAY" y las conversiones se desasignaran. ¿Deseas continuar?
          </p>
        </div>
        <div class="final-confirmation-actions">
          <v-btn
            outlined
            color="black"
            @click="showFinalConfirmationModal = false"
            class="cancel-btn"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="black"
            class="white--text accept-btn"
            @click="confirmStatusChange"
            :loading="isChangingStatus"
          >
            Aceptar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Modal de agregar facturas -->
    <v-dialog v-model="dialogAddInvoice" width="900px" persistent class="d-flex flex-column align-center justify-center">
      <v-overlay :value="isLoadingRelated" absolute>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-card style="border-radius: 10px; min-height:126px; max-height:1400px;" class="d-flex flex-column align-center justify-center">
        <v-card-title class="justify-center pb-6 pt-10" style="font-family: 'montserrat-bold'; font-size: 26px; color: #000; width: 100%; text-align: center;">Agregar factura</v-card-title>
        <v-card-subtitle class="text-center pb-12" style="font-family: 'montserrat-regular'; font-size: 14px; color: #000;"> Seleccione la factura que desea agregar al pago</v-card-subtitle>
        <!-- Barra de progreso -->
        <div style="width: 100%; display: flex; justify-content: flex-end; margin-bottom: 16px; max-height: 100px;" class="d-flex align-center pb-4 px-8">
          <div style="min-width: 450px; background: #fff; border: 1px solid #e0e0e0; border-radius: 16px; box-shadow: 0 2px 8px rgba(0,0,0,0.04); padding: 16px 20px 12px 20px; display: flex; flex-direction: column; align-items: flex-start;">
            <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; margin-bottom: 4px;">
              <span style="font-family: 'montserrat-bold'; font-size: 16px;">Monto cubierto {{ isMXAccount ? '(USD)' : '(MXN)' }}</span>
              <span style="font-family: 'montserrat-bold'; font-size: 16px;">
                ${{ formatMoney(amountCovered + selectedInvoicesLocal.filter(inv => !inv.isRelated).reduce((sum, inv) => sum + parseFloat(inv.dTotalAmount || 0), 0)) }} / ${{ formatMoney(amountTotal) }} {{ isMXAccount ? 'USD' : 'MXN' }}
              </span>
            </div>
            <v-progress-linear
              :value="amountTotal > 0 ? ((amountCovered + selectedInvoicesLocal.filter(inv => !inv.isRelated).reduce((sum, inv) => sum + parseFloat(inv.dTotalAmount || 0), 0)) / amountTotal) * 100 : 0"
              color="black"
              height="12"
              rounded
              background-color="#D3D3D3"
              style="width: 100%; margin-top: 2px;"
            />
          </div>
        </div>
        <!-- Select de facturas -->
        <v-card-text v-if="!isAmountFullyCovered" class="d-flex flex-column align-center justify-center px-10 py-6" style="background: #F6F8FC; border-radius: 16px; max-width: fit-content; min-width: 400px;  max-width: 450px; border: none; box-shadow: 0 2px 4px rgba(0,0,0,0.1); max-height: 25px;">
          <v-select
            v-model="selectedInvoiceIds"
            :items="filteredInvoicesAvailable"
            :item-text="item => 'PO: ' + (item.sId || '-') + ' | INV: ' + (item.sInvoice || '-') + ' - ' + formatMoney(item.dTotalAmount) + (isMXAccount ? ' USD' : ' MXN')"
            item-value="sInvoiceId"
            label="Facturas"
            dense
            class="no-border-select"
            multiple
            @change="handleSelectInvoices"
          >
          </v-select>
        </v-card-text>
        <!-- Facturas seleccionadas localmente -->
        <div v-if="selectedInvoicesLocal.length > 0" class="invoices-container">
          <div class="invoice-list-vertical">
            <div
              v-for="invoice in selectedInvoicesLocal"
              :key="invoice.sInvoiceId"
              class="invoice-card invoice-card-horizontal"
            >
              <div class="invoice-card-horizontal-content">
                <div class="invoice-card-horizontal-main">
                  <div class="invoice-title">Factura {{ invoice.sInvoice }}</div>
                  <div class="invoice-card-horizontal-row">
                    <div class="invoice-data-block">
                      <div class="label">Fecha de compra:</div>
                      <div class="value">{{ formatDate(invoice.dPurchaseDate) }}</div>
                    </div>
                    <template v-if="isMXAccount">
                      <div class="invoice-data-block">
                        <div class="label">Monto total:</div>
                        <div class="value">$ {{ formatMoney(invoice.dTotalAmount || 0) }} USD</div>
                      </div>
                      <div class="invoice-data-block">
                        <div class="label">Monto en MXN:</div>
                        <div class="value">$ {{ formatMoney((invoice.dTotalAmount || 0) * (invoice.dRateProtection || 0)) }} MXN</div>
                      </div>
                      <div class="invoice-data-block">
                        <div class="label">TC Protección:</div>
                        <div class="value">$ {{ formatMoney(invoice.dRateProtection) }} MXN</div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="invoice-data-block">
                        <div class="label">Monto total USD:</div>
                        <div class="value">$ {{ formatMoney(invoice.dTotalUsd || invoice.dAmount || 0) }} USD</div>
                      </div>
                      <div class="invoice-data-block">
                        <div class="label">Monto total MXN:</div>
                        <div class="value">$ {{ formatMoney(invoice.dTotalAmount) }} MXN</div>
                      </div>
                      <div class="invoice-data-block">
                        <div class="label">Protección TC:</div>
                        <div class="value">$ {{ formatMoney(invoice.dRateProtection) }} MXN</div>
                      </div>
                    </template>
                  </div>
                </div>
                <v-btn icon color="red" @click="invoice.isRelated ? openRemoveInvoiceDialog(invoice) : removeLocalInvoice(invoice.sInvoiceId)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
        <!--Boton de agregar-->
        <v-card-actions class="d-flex flex-row align-center justify-center py-8" style="width: 100%; gap: 16px;">
          <v-btn
            color="black"
            elevation="8"
            class="mr-2 px-10"
            style="border-radius: 36px; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            outlined
            @click="cancelAddInvoice()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="black"
            elevation="8"
            class="white--text px-10"
            style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
            @click="addInvoiceToPayment()"
            :disabled="isAddInvoiceDisabled || isLoadingRelated"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal de confirmación de eliminación de factura -->
    <v-dialog v-model="dialogRemoveInvoice" persistent max-width="fit-content">
      <v-card>
        <v-card-title class="text-h5 my-4">
          ¿Estás seguro que deseas eliminar esta factura?
        </v-card-title>
        <v-card-text class="my-6">
          Esta acción eliminará la factura <b>{{ invoiceToRemove?.sInvoice }}</b> de este pago. ¿Deseas continuar?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="dialogRemoveInvoice = false"> Cancelar </v-btn>
          <v-btn color="black" class="white--text" @click="confirmRemoveInvoice()">
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { mixs } from "@/mixins";

export default {
  name: "DashboardView",
  mixins: [mixs],
  props: {
    sPaymentId: {
      type: String,
      default: null,
    },
    asDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      nameXLSX: "HistorialPagos.xlsx",
      texts: "",
      loading: true,
      isLoading: false,
      headersInvoices: [
        this.selectLanguage === 'en' ? { text: "Invoice", value: "sInvoice", align: "center" } : { text: "Factura", value: "sInvoice", align: "center" },
        this.selectLanguage === 'en' ? { text: "Purchase Order", value: "sId", align: "center" } : { text: "Orden de compra", value: "sId", align: "center" },
        this.selectLanguage === 'en' ? { text: "Purchase date", value: "dPurchaseDate", align: "center" } : { text: "Fecha de compra", value: "dPurchaseDate", align: "center" },
        this.selectLanguage === 'en' ? { text: "Due date", value: "dDueDate", align: "center" } : { text: "Fecha de vencimiento", value: "dDueDate", align: "center" },
        this.selectLanguage === 'en' ? { text: "Status", value: "sStatusId", align: "center" } : { text: "Estado", value: "sStatusId", align: "center" },
        this.selectLanguage === 'en' ? { text: "Total amount MXN", value: "dTotalAmount", align: "center" } : { text: "Monto total MXN", value: "dTotalAmount", align: "center" },
        this.selectLanguage === 'en' ? { text: "Exchange rate protection MXN", value: "dRateProtection", align: "center", sortable: false } : { text: "Cobertura de tasa de cambio MXN", value: "dRateProtection", align: "center", sortable: false },   
        this.selectLanguage === 'en' ? { text: "Currency profit (%)", value: "dProfitPercentage", align: "center" } : { text: "Beneficio de moneda (%)", value: "dProfitPercentage", align: "center" },
        this.selectLanguage === 'en' ? { text: "Currency gain", value: "dCurrencyGain", align: "center" } : { text: "Beneficio de moneda", value: "dCurrencyGain", align: "center" },
        // this.selectLanguage === 'en' ? { text: "Actions", value: "actions", align: "center" } : { text: "Acciones", value: "actions", align: "center" }
      ],
      dTotalAmount: "",
      dDescAmount: "",
      item: null,
      invoices: [],
      showStatusModal: false,
      showFinalConfirmationModal: false,
      selectedStatus: null,
      statusOptions: [
        { id: '66a50b51-0f67-4891-a782-f9328a783b9d', name: 'Pendiente' },
        { id: '2659f31a-8564-46d9-996c-f13e6816549e', name: 'Completado' },
        { id: 'f1f776ab-2eb7-438d-9de7-13e9d91d07b9', name: 'Rechazado' },
      ],
      isChangingStatus: false,
      // Variables para agregar facturas
      dialogAddInvoice: false,
      dialogRemoveInvoice: false,
      invoiceToRemove: null,
      invoicesAvailable: [],
      selectedInvoicesLocal: [],
      selectedInvoiceIds: [],
      amountCovered: 0,
      amountTotal: 0,
      isLoadingRelated: false,
      accountType: null,
    };
  },
  created() {
    const id = this.sPaymentId || this.$route.params.sPaymentId;
    this.getPaymentsHistory(id);
  },
  watch: {
    sPaymentId(newId, oldId) {
      if (newId && newId !== oldId) {
        this.showStatusModal = false;
        this.showFinalConfirmationModal = false;
        this.dialogAddInvoice = false;
        this.dialogRemoveInvoice = false;
        this.selectedStatus = null;
        this.getPaymentsHistory(newId);
      }
    },
  },
  methods: {
    openReceipt(item) {
      this.loading = true;
      const payload = {
        sEnterpriseId: this.item.sEnterpriseId
      };

      DB.post(
        `${URI}/api/v1/en/administrator/payment/${this.item.sPaymentId}/openReceipt`, payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          },
          responseType: 'blob'
        }
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${this.item.payment_recipient.sName + (this.item.invoice ? "_" + this.item.invoice : "")}.pdf`;
        link.click();
      })
      .catch((error) => {
        this.mixError(
          error?.response?.data?.message || "No se pudo descargar el archivo",
          error?.response?.status || 500
        );
      })
      .finally(() => {
        this.loading = false;
      });
    },
    goToConversion(item) {
      this.$router.push("/conversion/" + item.sTransactionId);
    },
    goToInvoice(item) {
      this.$router.push("/invoice/" + item.sInvoiceId);
    },
    getPaymentsHistory(sPaymentId = null) {
      this.isLoading = true;
      const id = sPaymentId || this.$route.params.sPaymentId;
      DB.get(`${URI}/api/v1/en/administrator/payment/${id}`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
        .then((response) => {
          this.item = response.data.payment;

          this.accountType = this.item.sAccountType || 'EFEXUSD';

          this.item.invoice = this.item.invoice_payments_relationship
          this.item.dExchangeRateReal = this.item.transaction[0].transaction.dDesAmount / this.item.transaction[0].transaction.dAmount;
          let totalProtected = 0;
          let dollarProfit = 0;
          if (this.item.totalActualCost) {
            this.item.dAmount = parseFloat(this.item.totalActualCost)
          } else {
            this.item.dAmount = this.item.dDescAmount / this.item.dExchangeRateReal;
          }
          this.item.dTotalAmount = 0;
          if (this.item.invoice_payments_relationship) {
            this.item.invoice_payments_relationship.map((invoice) => {
              this.item.dTotalAmount += parseFloat(invoice.dAmount);
                return invoice;
            })
          }
          if (this.item.invoices) {
            this.item.invoices.map((invoice) => {
              const invData = invoice.invoice;
              const hasInvoiceProfit = invData && invData.dCurrencyGain != null && parseFloat(invData.dCurrencyGain) !== 0;

              if (hasInvoiceProfit) {
                invoice.profit = parseFloat(invData.dCurrencyGain);
                invoice.percentProfit = parseFloat(invData.dProfitPercentage || 0);
                dollarProfit += invoice.profit;
                totalProtected += parseFloat(invData.dProtectedUsd || invData.dProtectedAmount || 0);
              } else if (invData && invData.dRateProtection) {
                invoice.profit = (invoice.totalDescAmount / invData.dRateProtection) - invoice.totalOrignAmount;
                invoice.percentProfit = (invoice.profit / (invoice.totalDescAmount / invData.dRateProtection)) * 100;

                dollarProfit += invoice.profit;
                totalProtected += invoice.totalDescAmount / invData.dRateProtection;
              }
              return invoice;
            })
          }
          const hasPersistedProfit = this.item.dollarProfit != null && this.item.dollarProfit !== 0;
          if (!hasPersistedProfit) {
            this.item.dollarProfit = dollarProfit;
            this.item.percentProfit = (dollarProfit / totalProtected) * 100;
          }
          this.dTotalAmount = this.item.dTotalAmount;
          this.dDescAmount = this.item.dDescAmount;

        })
        .catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    formatMoney(value) {
      let multiplied = value * 100;
      let rounded = Math.round(multiplied);
      let formattedNumber = rounded / 100;
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(formattedNumber);
    },
    formatDate(date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM D, YYYY");
      return formattedDate;
    },
    setStatusColor(status) {
      if (status === "COMPLETED" || status === "DEPOSITED") {
        return "green";
      } else if(status === "PENDING_TO_PROCESS"){
        return "blue";
      } else if(status === "REJECTED"){
        return "red";
      }
       else {
        return "gray";
      }
    },
         changeStatus() {
       this.showStatusModal = true;
       this.selectedStatus = null; // No preseleccionar ningún estatus
     },
     showConfirmationModal() {
       this.showStatusModal = false;
       this.showFinalConfirmationModal = true;
     },
     getStatusName(statusId) {
       const status = this.statusOptions.find(option => option.id === statusId);
       return status ? status.name : statusId;
     },
         async confirmStatusChange() {
       this.isChangingStatus = true;
       try {
         const payload = {
           sStatusId: this.selectedStatus,
         };

                   await DB.put(
            `${URI}/api/v1/en/administrator/payment/${this.item.sPaymentId}/status`,
            payload,
            {
              headers: {
                Authorization: this.$store.state.sToken
                  ? `Bearer ${this.$store.state.sToken}`
                  : ""
              }
            }
          );
          this.mixSuccess("Estatus del pago actualizado con éxito.");
          this.showStatusModal = false;
          this.showFinalConfirmationModal = false;
          this.getPaymentsHistory();
       } catch (error) {
         this.mixError(
           error?.response?.data?.message || "No se pudo cambiar el estatus del pago",
           error?.response?.status || 500
         );
       } finally {
         this.isChangingStatus = false;
       }
     },
    // Métodos para agregar facturas
    async openAddInvoiceDialog() {
      this.dialogAddInvoice = true;
      this.isLoadingRelated = true;
      await this.getInvoicesAvailable();
      await this.fetchRelatedInvoices();
      this.selectedInvoiceIds = this.selectedInvoicesLocal.map(inv => inv.sInvoiceId);
      this.selectedInvoicesLocal = this.selectedInvoicesLocal.filter(inv => inv.isRelated);
      this.isLoadingRelated = false;
    },
    async getInvoicesAvailable() {
      const sEnterpriseId = this.item.sEnterpriseId ||
        (this.item.payment_recipient ? this.item.payment_recipient.sEnterpriseId : null);

      if (!sEnterpriseId) {
        this.invoicesAvailable = [];
        return;
      }

      try {
        if (this.isMXAccount) {
          const payload = { sEnterpriseId };
          const response = await DB.post(`${URI}/api/v1/en/administrator/invoicesMX/available`, payload, {
            headers: {
              Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""
            }
          });
          this.invoicesAvailable = (response.data.invoices || []).map(inv => ({
            ...inv,
            sInvoiceId: inv.sInvoiceMXId,
          }));
        } else {
          const sPaymentRecipientId = this.item.sPaymentRecipientId ||
            (this.item.payment_recipient ? this.item.payment_recipient.sPaymentRecipientId : null);

          if (!sPaymentRecipientId) {
            this.invoicesAvailable = [];
            return;
          }

          const payload = {
            currency: 'USD',
            des_currency: 'MXN',
            sExchangeRate: this.item.dRate,
            sPaymentRecipientId: sPaymentRecipientId,
            sEnterpriseId: sEnterpriseId
          };

          const response = await DB.post(`${URI}/api/v1/en/administrator/invoices/available`, payload, {
            headers: {
              Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""
            }
          });
          this.invoicesAvailable = response.data.invoices || [];
        }
      } catch (error) {
        console.error('[getInvoicesAvailable] Error:', error);
        this.invoicesAvailable = [];
      }
    },
    async fetchRelatedInvoices() {
      this.isLoadingRelated = true;
      try {
        const response = await DB.get(`${URI}/api/v1/en/administrator/payment/${this.item.sPaymentId}/related-invoices`, {
          headers: { Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : '' }
        });
        this.selectedInvoicesLocal = (response.data.invoices || []).map(inv => ({
          ...inv,
          sInvoiceId: inv.sInvoiceId || inv.sInvoiceMXId,
          isRelated: true
        }));
        this.amountCovered = response.data.amountCovered || 0;
        this.amountTotal = response.data.amountTotal || 0;
      } catch (e) {
        this.selectedInvoicesLocal = [];
        this.amountCovered = 0;
        this.amountTotal = 0;
      } finally {
        this.isLoadingRelated = false;
      }
    },
    handleSelectInvoices(val) {
      let totalCovered = this.amountCovered + this.selectedInvoicesLocal
        .filter(inv => !inv.isRelated)
        .reduce((sum, inv) => sum + parseFloat(inv.dTotalAmount || 0), 0);

      const newSelected = this.invoicesAvailable
        .filter(inv => val.includes(inv.sInvoiceId) && !this.selectedInvoicesLocal.some(sel => sel.sInvoiceId === inv.sInvoiceId));

      for (const invoice of newSelected) {
        const invoiceAmount = parseFloat(invoice.dTotalAmount || 0);
        if ((totalCovered + invoiceAmount) > this.amountTotal) {
          this.mixError('El monto de la factura excede el saldo restante a cubrir.', 400);
          this.selectedInvoiceIds = this.selectedInvoiceIds.filter(id => id !== invoice.sInvoiceId);
          continue;
        }
        totalCovered += invoiceAmount;
        this.selectedInvoicesLocal.push({ ...invoice, isRelated: false });
      }
    },
    removeLocalInvoice(sInvoiceId) {
      this.selectedInvoicesLocal = this.selectedInvoicesLocal.filter(inv => inv.sInvoiceId !== sInvoiceId);
      this.selectedInvoiceIds = this.selectedInvoiceIds.filter(id => id !== sInvoiceId);
    },
    async removeRelatedInvoice(invoice) {
      this.isLoadingRelated = true;
      const sInvoiceId = invoice.sInvoiceId || invoice.sInvoiceMXId;
      const isMX = Boolean(invoice.sInvoiceMXId);
      const url = isMX
        ? `${URI}/api/v1/en/administrator/payment/${this.item.sPaymentId}/invoicesMX/${sInvoiceId}`
        : `${URI}/api/v1/en/administrator/payment/${this.item.sPaymentId}/invoices/${sInvoiceId}`;
      try {
        await DB.delete(url, {
          headers: { Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : '' }
        });
        await this.fetchRelatedInvoices();
        await this.getInvoicesAvailable();
        this.selectedInvoicesLocal = this.selectedInvoicesLocal.filter(inv => inv.isRelated);
        this.selectedInvoiceIds = this.selectedInvoicesLocal.map(inv => inv.sInvoiceId);
        this.mixSuccess('Factura eliminada correctamente', 200);
      } catch (e) {
        this.mixError(e?.response?.data?.message || 'No se pudo desasociar la factura', e?.response?.status || 500);
      } finally {
        this.isLoadingRelated = false;
      }
    },
    openRemoveInvoiceDialog(invoice) {
      this.invoiceToRemove = invoice;
      this.dialogRemoveInvoice = true;
    },
    confirmRemoveInvoice() {
      if (this.invoiceToRemove) {
        if (this.invoiceToRemove.isRelated) {
          this.removeRelatedInvoice(this.invoiceToRemove);
        } else {
          this.removeLocalInvoice(this.invoiceToRemove.sInvoiceId);
        }
      }
      this.dialogRemoveInvoice = false;
      this.invoiceToRemove = null;
    },
    async addInvoiceToPayment() {
      if (!this.selectedInvoicesLocal.length) return;
      this.isLoadingRelated = true;

      const uniqueInvoices = [];
      const seen = new Set();
      for (const invoice of this.selectedInvoicesLocal) {
        if (!invoice.isRelated && !seen.has(invoice.sInvoiceId)) {
          uniqueInvoices.push(invoice);
          seen.add(invoice.sInvoiceId);
        }
      }

      if (uniqueInvoices.length === 0) {
        this.isLoadingRelated = false;
        this.dialogAddInvoice = false;
        return;
      }

      try {
        let endpoint, payload;
        if (this.isMXAccount) {
          endpoint = `${URI}/api/v1/en/administrator/payment/${this.item.sPaymentId}/addInvoiceMX`;
          payload = {
            sInvoiceMXIds: uniqueInvoices.map(inv => inv.sInvoiceId)
          };
        } else {
          endpoint = `${URI}/api/v1/en/administrator/payment/${this.item.sPaymentId}/addInvoice`;
          payload = {
            sInvoiceIds: uniqueInvoices.map(inv => inv.sInvoiceId)
          };
        }

        const response = await DB.post(endpoint, payload, {
          headers: { Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : '' }
        });

        if (response.data && response.data.success) {
          this.mixSuccess(response.data.message || 'Facturas agregadas correctamente', 200);
        } else {
          this.mixError(response.data.message || 'Error al agregar facturas', 400);
        }
        this.dialogAddInvoice = false;
        this.selectedInvoicesLocal = [];
        this.selectedInvoiceIds = [];
        this.getPaymentsHistory();
      } catch (e) {
        this.mixError(e?.response?.data?.message || 'No se pudo agregar la factura', e?.response?.status || 500);
      } finally {
        this.isLoadingRelated = false;
      }
    },
    cancelAddInvoice() {
      this.dialogAddInvoice = false;
      this.selectedInvoicesLocal = [];
      this.selectedInvoiceIds = [];
    },
  },
  beforeCreated() {
  },
  computed: {
    isMXAccount() {
      return this.accountType === 'EFEXMXN';
    },
    isAddInvoiceDisabled() {
      return !this.selectedInvoicesLocal.length;
    },
    isAmountFullyCovered() {
      return (
        this.amountTotal > 0 &&
        (this.amountCovered +
          this.selectedInvoicesLocal
            .filter(inv => !inv.isRelated)
            .reduce((sum, inv) => sum + parseFloat(inv.dTotalAmount || 0), 0)
        ) >= this.amountTotal
      );
    },
    filteredInvoicesAvailable() {
      const selectedIds = this.selectedInvoicesLocal.map(inv => inv.sInvoiceId);
      return this.invoicesAvailable.filter(inv => !selectedIds.includes(inv.sInvoiceId));
    },
    totalMXNUsed() {
      if (!this.item || !this.item.transaction || this.item.transaction.length === 0) {
        return 0;
      }
      return this.item.transaction.reduce((sum, item) => {
        return sum + parseFloat(item.dAmount || 0);
      }, 0);
    },
    totalUSDUsed() {
      if (!this.item || !this.item.transaction || this.item.transaction.length === 0) {
        return 0;
      }
      return this.item.transaction.reduce((sum, item) => {
        const usdUsed = parseFloat(item.dAmount || 0) / (item.transaction.dDesAmount / item.transaction.dAmount);
        return sum + usdUsed;
      }, 0);
    },
    totalInvoicesMXN() {
      if (!this.item || !this.item.invoices || this.item.invoices.length === 0) {
        return 0;
      }
      return this.item.invoices.reduce((sum, item) => {
        if (this.isMXAccount) {
          return sum + (parseFloat(item.invoice.dTotalAmount || 0) * parseFloat(item.invoice.dRateProtection || 0));
        } else {
          return sum + parseFloat(item.totalDescAmount || 0);
        }
      }, 0);
    },
    totalInvoicesUSD() {
      if (!this.item || !this.item.invoices || this.item.invoices.length === 0) {
        return 0;
      }
      return this.item.invoices.reduce((sum, item) => {
        if (this.isMXAccount) {
          return sum + parseFloat(item.invoice.dTotalAmount || 0);
        } else {
          return sum + parseFloat(item.totalOrignAmount || 0);
        }
      }, 0);
    }
  },
  watch: {
  }
};
</script>

<style scoped>
.text-return {
  font-family: "montserrat-medium";
}

.info-card {
  border: 1px #bbbbbb solid;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.35) !important;
  background-color: white;
  border-radius: 20px;
  padding: 16px;
}

.info-block {
  background-color: #F6F8FC;
  border-radius: 10px;
  padding: 8px;
  margin-bottom: 10px;
}

.label {
  color: #868DA6;
  font-family: "montserrat-bold";
  font-size: 14px;
  margin-bottom: 2px;
  padding: 5px;
  width: fit-content;
}

.value {
  color: black;
  font-family: "montserrat-bold";
  font-size: 16px;
  padding: 5px;
  margin-bottom: 5px;
  width: fit-content;
}

.profit-text {
  color: #0075B8;
}

.amount-text {
  font-size: 22px;
  color: black;
  font-family: "montserrat-bold";
}

.action-btn {
  border-radius: 36px;
  font-family: "montserrat-semibold";
  text-transform: none;
  border: 2px solid #0075BB;
}

.action-btn.primary {
  background-color: #0075B8;
  color: white;
}

.v-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Estilos para el modal de cambio de estatus */
.status-modal {
  border-radius: 20px !important;
  background-color: #fff;
  overflow: hidden;
  padding: 0;
}

.warning-icon {
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 10;
  margin-bottom: -40px;
}

.status-modal-content {
  background-color: #000;
  color: white;
  text-align: center;
  padding: 20px 40px;
  margin: 50px 40px 20px 40px;
  border-radius: 15px;
  padding-top: 40px;
  padding-bottom: 40px;
}

.status-selection-section {
  background-color: #f5f5f5;
  color: #333;
  padding: 5px 40px;
  margin: 0 40px 20px 40px;
  border-radius: 15px;
}

.payment-details-section {
  background-color: #f5f5f5;
  color: #333;
  padding: 25px 40px;
  margin: 0 40px 40px 40px;
  border-radius: 15px;
}

.warning-icon-outer {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #333;
  border: 3px solid #666;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: 20px;
}

.warning-icon-inner {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.warning-exclamation {
  color: white;
  font-size: 36px;
  font-weight: bold;
  font-family: Arial, sans-serif;
}

.status-modal-title {
  font-family: 'montserrat-bold';
  font-size: 22px;
  margin-bottom: 0;
  line-height: 1.3;
  font-weight: 700;
  color: white;
}

.status-selection {
  margin-bottom: 20px;
  text-align: left;
}

.status-label {
  font-family: 'montserrat-medium';
  font-size: 16px;
  margin-bottom: 10px;
  display: block;
  color: #333;
}

.payment-details {
  margin-top: 20px;
  text-align: left;
}

.detail-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  padding: 8px 0;
}

.detail-label {
  color: #646464;
  font-family: 'montserrat-bold';
  font-weight: 600;
  text-align: left;
}

.detail-value {
  color: #737583;
  font-family: 'montserrat-bold';
  text-align: left;
}

.status-modal-actions {
  background-color: white;
  padding: 20px 30px 30px 30px;
  display: flex;
  justify-content: center;
  gap: 20px;
}

.cancel-btn {
  width: 120px;
  border-radius: 36px !important;
  border: 2px solid #000000 !important;
  font-family: 'montserrat-semibold' !important;
  text-transform: none !important;
  height: 42px;
  font-weight: 600;
  font-size: 14px;
}

.accept-btn {
  width: 120px;
  border-radius: 36px !important;
  font-family: 'montserrat-semibold' !important;
  text-transform: none !important;
  height: 42px;
  font-weight: 600;
  font-size: 14px;
}

/* Estilos para el modal de confirmación final */
.final-confirmation-modal {
  border-radius: 20px !important;
  background-color: #fff;
  overflow: hidden;
  padding: 0;
}

.final-confirmation-content {
  background-color: #000;
  color: white;
  text-align: center;
  padding: 50px 40px 40px 40px;
  margin: 50px 40px 40px 40px;
  border-radius: 15px;
}

.final-confirmation-title {
  font-family: 'montserrat-bold';
  font-size: 22px;
  margin-bottom: 20px;
  line-height: 1.3;
  font-weight: 700;
}

.final-confirmation-description {
  font-family: 'montserrat-medium';
  font-size: 16px;
  line-height: 1.4;
  opacity: 0.95;
  margin: 0;
}

.final-confirmation-actions {
  background-color: white;
  padding: 20px 30px 30px 30px;
  display: flex;
  justify-content: center;
  gap: 20px;
}

/* Estilos para el modal de agregar facturas */
.no-border-select >>> .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

.no-border-select >>> .v-input__slot {
  border: none !important;
  box-shadow: none !important;
}

.no-border-select >>> .v-input__slot::before {
  border: none !important;
}

.no-border-select >>> .v-input__slot::after {
  border: none !important;
}

.no-border-select >>> .v-text-field__slot {
  border: none !important;
}

.no-border-select >>> .v-text-field__slot::before {
  border: none !important;
}

.no-border-select >>> .v-text-field__slot::after {
  border: none !important;
}

.invoice-list-vertical {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.invoice-card {
  background: #F2F2F2;
  border-radius: 24px;
  box-sizing: border-box;
  box-shadow: none;
  margin: 0 auto;
  width: 100%;
  max-width: 850px;
  overflow: auto;
  padding: 20px 28px 18px 28px;
  transition: all 0.3s;
}

.invoice-card-horizontal-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.invoice-card-horizontal-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.invoice-title {
  font-size: 1.5rem;
  font-family: 'montserrat-bold';
  color: #222;
  margin-bottom: 12px;
}

.invoice-card-horizontal-row {
  display: flex;
  flex-direction: row;
  gap: 32px;
}

.invoice-data-block {
  min-width: 120px;
  max-width: 160px;
}

.invoice-data-block .label {
  color: #868DA6;
  font-family: "montserrat-bold";
  font-size: 12px;
  margin-bottom: 2px;
  padding: 0;
}

.invoice-data-block .value {
  color: black;
  font-family: "montserrat-bold";
  font-size: 14px;
  padding: 0;
  margin-bottom: 0;
}

.invoices-container {
  width: 100%;
  margin-bottom: 16px;
  margin-top: 16px;
  max-height: 400px;
  overflow-y: auto;
  padding: 0 32px;
}

.invoices-container::-webkit-scrollbar {
  width: 8px;
}

.invoices-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.invoices-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.invoices-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
